import {InputErrorManager} from "../InputValidationHandler";
import {ErrorVisibilityManager} from "../ErrorVisibilityManager";

export class DefaultEmailInputErrorManager implements InputErrorManager {
    manageError(element: HTMLInputElement, isValid: boolean) {
        ErrorVisibilityManager.manageErrorVisibility(element, isValid)
    }
}
